import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const getCountName = (value) => {
  switch (value) {
  case '&infin':
    return '∞'
  default:
    return value;
  }
}

export const PostCount = ({ url, value }) => {
  const name = getCountName(value);
  if (url) {
    return (
      <Link to={url}>{name}</Link>
    )
  }
  return name;
}

PostCount.propTypes = {
  url: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default PostCount;
